import { CosmeticType } from '@profile/src/utils/types';
export const FilterButtons = {
  all: 'All',
  [CosmeticType.AVATAR]: 'Avatar',
  [CosmeticType.AVATAR_FRAME]: 'Avatar Frame',
  [CosmeticType.EMOTE]: 'Emote',
  [CosmeticType.SPACESHIP]: 'Spaceship'
};
export function slugify(input) {
  return input.toLowerCase().replace(/\s+/g, '-');
}